import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ApiErrorDiagnostics } from '~/Interfaces';
import { selectFreshApiErrorDiagnostics } from '~/store/selectors/globalError.selector';

// Latched while mounted: persistent error states (e.g. a failed offer page) keep
// showing the diagnostics after the selector's TTL expires.
export const useLatchedApiErrorDiagnostics = ():
  | ApiErrorDiagnostics
  | undefined => {
  const freshDiagnostics = useSelector(selectFreshApiErrorDiagnostics);
  const [latchedDiagnostics, setLatchedDiagnostics] = useState(
    freshDiagnostics
  );

  if (freshDiagnostics && freshDiagnostics !== latchedDiagnostics) {
    setLatchedDiagnostics(freshDiagnostics);
  }

  return freshDiagnostics ?? latchedDiagnostics;
};
